import { action } from 'satcheljs';
import { DateRange } from 'owa-datetime-utils';
import { LoadState } from '../store/schema/LoadState';
import { CalendarCacheScenarioId } from 'owa-calendar-cache';

export const updateLoadedDateRange = action(
    'updateLoadedDateRange',
    (dateRange: DateRange, scenarioId: CalendarCacheScenarioId) => ({ dateRange, scenarioId })
);

export const updateLoadedFolderIds = action(
    'updateLoadedFolderIds',
    (folderIds: string[], scenarioId: CalendarCacheScenarioId) => ({ folderIds, scenarioId })
);

export const updateLoadState = action(
    'updateLoadState',
    (loadState: LoadState, scenarioId: CalendarCacheScenarioId) => ({
        scenarioId,
        loadState,
    })
);

export const initializeScenario = action(
    'initializeScenario',
    (scenarioId: CalendarCacheScenarioId) => ({
        scenarioId,
    })
);

export const updateIsInitializingCalendarEventsLoader = action(
    'updateIsInitializingCalendarEventsLoader',
    (isInitializingCalendarEventsLoader: boolean, scenarioId: CalendarCacheScenarioId) => ({
        scenarioId,
        isInitializingCalendarEventsLoader,
    })
);
